import { Delete, Edit } from "@mui/icons-material";
import dayjs from "dayjs";

export const getCultureActions = ({
  navigate,
  routerPaths,
  setSelectedCulture,
  setSelectedAction,
  setDialogOpen,
}) => [
  {
    icon: Edit,
    tooltip: "Modifica",
    onClick: (rowId) => navigate(`${routerPaths.updateCulture}/${rowId}`),
  },
  {
    icon: Delete,
    tooltip: "Elimina",
    onClick: (rowId) => {
      setSelectedCulture(rowId);
      setSelectedAction("delete");
      setDialogOpen(true);
    },
  },
];

export const getActualCulture = (field_crops) => {
  if (!field_crops || !Array.isArray(field_crops) || field_crops.length === 0) {
    return null;
  }

  const today = dayjs();

  for (const crop of field_crops) {
    const culture = crop?.colture;

    if (!culture || !crop.start_date || !crop.end_date) {
      continue;
    }

    const startDate = dayjs(crop.start_date);
    const endDate = dayjs(crop.end_date);

    const isAfterOrSameStart = today.diff(startDate, "day") >= 0;
    const isBeforeOrSameEnd = today.diff(endDate, "day") <= 0;
    const isCurrent = isAfterOrSameStart && isBeforeOrSameEnd;

    if (isCurrent) {
      return culture;
    }
  }

  return null;
};
